import React, { useState } from 'react';
import { Play, Star, Youtube } from 'lucide-react';
import { BRAND } from './brand';
import './video-reviews.css';

// Client review videos from the "Client Reviews | VK Tours" YouTube playlist.
// To add a video: copy the 11-character id from its YouTube link (watch?v=XXXXXXXXXXX).
export const REVIEW_VIDEOS = [
  { id: '9Y9Lnlvd5Jo', name: 'Mrs. Padma Garu', place: 'Vijayawada', trip: 'Assam & Meghalaya tour', length: '1:12' },
  { id: '1L8KJz_SWsg', name: 'Mr. Surya Reddy', place: 'Corporate group', trip: 'Malaysia group tour', length: '0:55' },
  { id: 'IcnVEZxZM_g', name: 'Mr. Gyanender Garu', place: 'Andhra Pradesh', trip: 'Meghalaya tour', length: '0:35' },
  { id: '9s6htWxWspg', name: 'Mr. Prasad', place: 'Corporate group', trip: 'Malaysia group tour', length: '0:54' },
];

const VideoCard = ({ v }) => {
  const [play, setPlay] = useState(false);
  return (
    <figure className="vk-vr__card">
      <div className="vk-vr__media">
        {play ? (
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${v.id}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
            title={`${v.name} — ${v.trip} review`}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
          />
        ) : (
          <button type="button" className="vk-vr__thumb" onClick={() => setPlay(true)} aria-label={`Play review by ${v.name}, ${v.trip}`}>
            <img src={`https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }} />
            <span className="vk-vr__play" aria-hidden="true"><Play size={26} fill="currentColor" /></span>
            {v.length ? <span className="vk-vr__len">{v.length}</span> : null}
          </button>
        )}
      </div>
      <figcaption>
        <b>{v.name}</b>
        <span>{v.trip} · {v.place}</span>
      </figcaption>
    </figure>
  );
};

const VideoReviews = ({ title = 'Hear it from our travellers', kicker = 'Real guests · real reviews' }) => (
  <section className="vk-section vk-vr" aria-labelledby="vk-vr-title">
    <div className="vk-wrap">
      <div className="vk-vr__head">
        <div>
          <p className="vk-kicker">{kicker}</p>
          <h2 id="vk-vr-title" className="vk-display vk-h2">{title}</h2>
        </div>
        <div className="vk-vr__proof">
          <a href={BRAND.googleReviews} target="_blank" rel="noopener noreferrer" className="vk-vr__badge">
            <Star size={18} fill="#ffc531" color="#ffc531" />
            <span><b>{BRAND.googleRating} / 5</b> on Google</span>
          </a>
          <a href={BRAND.youtube} target="_blank" rel="noopener noreferrer" className="vk-vr__badge">
            <Youtube size={20} color="#ff0000" />
            <span><b>Video reviews</b> on YouTube</span>
          </a>
        </div>
      </div>

      <div className="vk-vr__row">
        {REVIEW_VIDEOS.map((v) => <VideoCard key={v.id} v={v} />)}
      </div>

      <div className="vk-vr__actions">
        <a className="vk-btn vk-btn--dark" href={BRAND.youtubeReviews} target="_blank" rel="noopener noreferrer"><Youtube size={18} /> Watch all client reviews</a>
        <a className="vk-btn vk-btn--outline" href={`${BRAND.youtube}?sub_confirmation=1`} target="_blank" rel="noopener noreferrer">Subscribe to VK Tours</a>
      </div>
    </div>
  </section>
);

export default VideoReviews;
